
(function () {
 function initCommerce() {
  const root = document.getElementById('fitbite');
  const config = document.getElementById('fb-shopify-config');
  if (!root || !config || root.dataset.fbCommerceReady) return;
  root.dataset.fbCommerceReady = 'true';
  const ready = config.dataset.ready === 'true';
  root.querySelectorAll('[data-fb-price]').forEach(function (node) {
    node.textContent = config.dataset.price;
  });
  root.querySelectorAll('[data-fb-buy]').forEach(function (node) {
    if (!ready) {
      node.setAttribute('aria-disabled', 'true');
      if (node.tagName === 'BUTTON') node.disabled = true;
      node.textContent = 'Currently unavailable';
    }
  });
  root.addEventListener('click', function (event) {
    const target = event.target.closest('[data-fb-buy]');
    if (!target || !root.contains(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!ready) return;
    document.getElementById('fb-native-product-form').requestSubmit();
  }, true);
 }
 initCommerce();
 document.addEventListener('shopify:section:load', initCommerce);
})();
